// extracted by mini-css-extract-plugin
export var adjacentSlide = "_te-9";
export var arrowButtonContainer = "_te-5";
export var arrowButtonIcon = "_te-6";
export var carouselArrowButton = "_te-2";
export var carouselElementContainer = "_te-1";
export var currentSlide = "_te-8";
export var left = "_te-3";
export var otherSlide = "_te-a";
export var productCarouselContainer = "_te-0";
export var right = "_te-4";
export var sliderOverflow = "_te-7";